import { useTranslation } from "react-i18next";

export default function useSeriesDropdownMenuOptions() {
	const { t } = useTranslation();

	return ({ serie }) => [
		{
			text: t("view", "View"),
			linkTo: `/publisher/${serie.publisher.id}/series/${serie.id}`,
		},
	];
}
